<template>
  <div v-if="store.filters.ctg8p1 && store.filters.ctg8p1.length > 0" class="filter d-flex flex-column">
    <h5 class="margin-0">
      {{ t('vehicle-category') }}
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>

    <div
      v-for="category in store.filters.ctg8p1"
      :key="category.id"
      class="collapse show"
      id="ctg8p1"
    >
      <div class="info d-flex align-items-center category">
        <div :class="['icon', 'icon-' + category]"></div>
        <input-checkbox
          class="ms-2 me-2"
          :field-name="category.id"
          field-value=""
          :checkedCondition="true"
          @clicked="setFilter(category)"
        />
        <p class="margin-0">{{ category }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import InputCheckbox from "../InputCheckbox.vue";

export default {
  props: {
    store: { required: true },
  },
  components: { InputCheckbox },
  name: "VehicleCategoriesFilterView",
  methods: {
    setFilter(index) {
      this.store.addItem(
        "VehicleCategories",
        this.store.vehicleCategories.indexOf(index)
      );
    },
    removeFilter() {
      this.store.removeItem("ctg8p1");
    },
  },
};
</script>
<style scoped>
.filter {
  width: 100%;
}

.filter h5 {
  /* margin: 0; */
  padding: 10px 20px;
  background-color: white;
  position: relative;
  background: white url("../../assets/h-filter-bg.png") repeat-y right top;
}
.filter .collapse {
  margin: 1px 0;
}
.filter .collapse:nth-of-type(1) {
  margin-top: 10px;
}
.filter .collapse:last-child {
  margin-bottom: 10px;
}
.info {
  font-size: 12px;
  padding: 0 20px;
}

.info .container {
  max-width: 10px;
}

.info p {
  font-size: 12px;
  /* margin: 0; */
}

.info.category {
  /* padding: 6px 20px; */
  padding: 1rem 1rem 1rem 3rem;
  font-size: 12px;
  display: flex;
  align-items: center;
  /* gap: 10px; */
  /* background-color: #f6f6f6; */
  border-bottom: 1px solid #ddd;
}

.info.category .icon {
  width: 30px;
  height: 30px;
  margin: 0.5rem 1rem 0.5rem 1rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 11px;
  right: 10px;
}
.icon-collapse {
  background: url("../../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}
.collapsed.icon-collapse {
  background: url("../../assets/icons/rozwin.png") no-repeat left top;
}
.category {
  position: relative;
}

.info.category :deep(.container),
.info.category :deep(.container2) {
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  flex: 0 0 18px;
  aspect-ratio: 1 / 1;
}

.info.category :deep(.checkmark),
.info.category :deep(.vio) {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

/* .icon {
  margin: 5px;
  height: 15px;
  width: 35px;
  left: 55px;
} */

/*
.icon-2 {
  background: url("../../assets/icons/kategoria-2.png") no-repeat left top;
}
.icon-3 {
  background: url("../../assets/icons/kategoria-3.png") no-repeat left top;
}
.icon-5 {
  background: url("../../assets/icons/kategoria-5.png") no-repeat left top;
}
.icon-7 {
  background: url("../../assets/icons/kategoria-7.png") no-repeat left top;
}
.icon-8 {
  background: url("../../assets/icons/kategoria-8.png") no-repeat left top;
}
.icon-9 {
  background: url("../../assets/icons/kategoria-9.png") no-repeat left top;
}
.icon-10 {
  background: url("../../assets/icons/kategoria-10.png") no-repeat left top;
  left: 60px;
}
.icon-11 {
  background: url("../../assets/icons/kategoria-11.png") no-repeat left top;
  left: 60px;
} */
</style>
